<template>
  <div class="tutorial-container">

    <div class="coming-soon">
      <div class="coming-soon-content">
        <el-icon size="60" color="#909399"><Clock /></el-icon>
        <h2>教程正在筹备中...</h2>
        <p>我们正在为这款插件制作详细的使用教程，敬请期待！</p>
        <el-button type="primary" @click="goBack">返回插件详情</el-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

// 获取路由参数
const pluginTutorial = ref(route.params.pluginTutorial)

// 计算对应的插件ID（反向映射）
const pluginId = computed(() => {
  const tutorialToIdMap = {
    'ebistudy': 1978297871453697,
    'qrcodetutorial': 1,
    'cuttingmodeltutorial': 2,
    'energyefficiencytutorial': 3,
    'arrowpositiontutorial': 4
  };

  return tutorialToIdMap[pluginTutorial.value] || 0;
});

// 返回插件详情页
const goBack = () => {
  if (pluginId.value) {
    router.push({
      path: '/products',
      query: { id: pluginId.value }
    });
  } else {
    router.push('/pluginlist');
  }
}
</script>

<style scoped>
.tutorial-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  min-height: 100%;
}

.tutorial-header {
  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e4e7ed;
}

.tutorial-header h1 {
  font-size: 2.5rem;
  color: #303133;
  margin-bottom: 10px;
}

.subtitle {
  font-size: 1.2rem;
  color: #909399;
}

.tutorial-content {
  display: flex;
  gap: 40px;
}

.toc {
  flex: 0 0 250px;
  position: sticky;
  top: 100px;
  height: fit-content;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.toc h2 {
  font-size: 1.2rem;
  margin-bottom: 15px;
  color: #303133;
}

.toc ul {
  list-style: none;
  padding: 0;
}

.toc li {
  margin-bottom: 10px;
}

.toc a {
  color: #606266;
  text-decoration: none;
  transition: color 0.3s;
}

.toc a:hover {
  color: #409eff;
}

.tutorial-sections {
  flex: 1;
}

.tutorial-section {
  margin-bottom: 60px;
  padding-bottom: 40px;
  border-bottom: 1px solid #f0f0f0;
}

.tutorial-section h2 {
  font-size: 1.8rem;
  color: #303133;
  margin-bottom: 20px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
}

.step {
  background: #fff;
  padding: 25px;
  border-radius: 8px;
  margin-bottom: 25px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.step h3 {
  color: #409eff;
  margin-bottom: 15px;
  font-size: 1.2rem;
}

.step ol, .step ul {
  padding-left: 20px;
  margin-bottom: 20px;
}

.step li {
  margin-bottom: 8px;
  line-height: 1.6;
}

.image-placeholder {
  width: 100%;
  height: 300px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  border: 1px dashed #c0c4cc;
}

.image-placeholder p {
  color: #909399;
  font-size: 1.1rem;
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.faq-item {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid #409eff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.faq-item h3 {
  color: #303133;
  margin-bottom: 10px;
}

.faq-item p {
  color: #606266;
  line-height: 1.6;
}

/* 敬请期待样式 */
.coming-soon {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}

.coming-soon-content {
  text-align: center;
  max-width: 500px;
  padding: 40px;
  background: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.coming-soon h2 {
  margin: 20px 0 10px;
  color: #f35e3b;
}

.coming-soon p {
  color: #909399;
  margin-bottom: 30px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .tutorial-content {
    flex-direction: column;
  }

  .toc {
    position: static;
    margin-bottom: 30px;
  }

  .tutorial-header h1 {
    font-size: 2rem;
  }
}
</style>